import { FINWAY_LEGAL_DATA } from "@finway-group/shared/lib/consts/common"
import { Col, Row } from "antd"
import React from "react"
import i18n from "Shared/locales/i18n"

export const EInvoiceFooter = () => (
    <div className="mt-10 text-xs">
        <Row className="font-medium text-black">{i18n.t("label:generated_by")}:</Row>
        <Row>{FINWAY_LEGAL_DATA.name}</Row>
        <Row>
            <Col span={7}>{FINWAY_LEGAL_DATA.street}</Col>
            <Col>{FINWAY_LEGAL_DATA.email}</Col>
        </Row>
        <Row>
            <Col span={7}>
                {FINWAY_LEGAL_DATA.zip} {FINWAY_LEGAL_DATA.city}
            </Col>
            <Col>{FINWAY_LEGAL_DATA.phone}</Col>
        </Row>
    </div>
)
